import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Button } from '../../atoms/button';
import { FontAwesomeIcon } from '../../atoms/icon/icon';
import { ProductiveHeading06 } from '../../styles';

const Header = styled.div`
  height: var(--layout-06);
  background: var(--gray-80);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  padding: var(--layout-01);
  ${ProductiveHeading06};
  color: white;
  margin-bottom: var(--layout-01);
`;

const CloseButton = styled(Button).attrs({
  type: 'text',
  shape: 'circle',
  icon: <FontAwesomeIcon icon={faXmark} fill="white" />,
})`
  position: absolute;
  top: var(--spacing-02);
  right: var(--spacing-02);
`;

const Panel = styled.aside<{ width?: number; visible?: boolean }>`
  --action-panel-header-background: var(--coolest-gray-10);
  --action-panel-shadow: var(--shadow-04);

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  ${({ width = 256, visible }) => css`
    min-width: ${visible ? width : 0}px;
    max-width: ${visible ? width : 0}px;
    width: ${visible ? width : 0}px;
    flex: 0 0 ${visible ? width : 0}px;
  `};
  box-shadow: var(--action-panel-shadow);
  transition: all var(--animation-duration-fast);
`;

const Body = styled.div`
  overflow: scroll;
  padding-bottom: var(--spacing-10);
`;

type Props = ComponentPropsWithoutRef<typeof Panel> & {
  title?: ReactNode;
  onClose?: () => void;
};

/* eslint-disable react/jsx-props-no-spreading */
export const ActionPanel: FC<React.PropsWithChildren<Props>> = ({
  title,
  onClose,
  children,
  visible,
  ...rest
}) => (
  <Panel {...rest} visible={visible} data-cy="action-panel">
    {visible ? (
      <>
        <CloseButton onClick={onClose} data-cy="action.panel.close-btn" />
        <Header data-cy="action.panel.header">{title}</Header>
        <Body>{children}</Body>
      </>
    ) : null}
  </Panel>
);
/* eslint-enable react/jsx-props-no-spreading */
